import React, { useState, useEffect } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import Header from "./homepage/Header";

function SignUp() {
  const [userType, setUserType] = useState("");
  const navigate = useNavigate();

  const handleUserTypeChange = (event) => {
    const selectedUserType = event.target.value;
    setUserType(selectedUserType);

    if (selectedUserType === "agent") {
      navigate("/tc/signup");
    } else if (selectedUserType === "driver") {
      navigate("/driver/signup");
    }
  };

  return (
    <div className="container">
      <div>
        <Header />
        {/* Sign-up Form */}
        <section>
          <div className="container mt-1 pt-4">
            <div className="row">
              <div className="col-12 col-sm-7 col-md-6 m-auto">
                <div className="card border-0 shadow custom-card">
                  <div className="card-body p-4 ">
                    {/* User Icon */}
                    <div className="d-flex justify-content-center mb-2">
                      <i className="fa-solid fa-user"></i>
                    </div>
                    {/* Select Type of User */}
                    <div className="row justify-content-center mt-4">
                      <div className="col-6">
                        <select
                          id="inputUser"
                          className="form-select"
                          value={userType}
                          onChange={handleUserTypeChange}
                        >
                          <option value="" disabled>
                            Select User Type
                          </option>
                          <option value="agent">Traffic Agent</option>
                          <option value="driver">
                            Driver or Vehicle Owner
                          </option>
                        </select>
                      </div>
                    </div>
                    {/* Redirect */}
                    <div className="text-center mt-3 text-light">
                      <p className="p-2">
                        Already have an Account?
                        <br />
                        <NavLink
                          className="btn text-light"
                          type="button"
                          to="/login"
                        >
                          Login
                        </NavLink>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default SignUp;
